import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEmptyFile = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 40,
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M20.433.5c.47 0 .921.187 1.253.52l9.75 9.75c.333.332.519.783.52 1.253v22.159a5.319 5.319 0 0 1-5.318 5.318H5.365a5.32 5.32 0 0 1-5.318-5.318V5.818A5.319 5.319 0 0 1 5.365.5h15.068ZM5.365 4.046a1.774 1.774 0 0 0-1.773 1.772v28.364a1.774 1.774 0 0 0 1.773 1.772h21.273a1.772 1.772 0 0 0 1.772-1.772v-19.5h-8.863c-.98 0-1.774-.794-1.774-1.773V4.046H5.365Zm9.75 14.181a6.204 6.204 0 0 1 5.457 9.156l2 2a1.773 1.773 0 0 1-2.507 2.507l-1.999-2a6.205 6.205 0 1 1-2.951-11.662Zm0 3.546a2.66 2.66 0 0 0 0 5.318c.628 0 1.203-.22 1.658-.583a1.786 1.786 0 0 1 .418-.418c.364-.455.583-1.03.583-1.658a2.66 2.66 0 0 0-2.659-2.66Zm6.204-10.636h5.471l-5.47-5.471v5.47Z" })
});
export default SvgEmptyFile;
